import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-528dcca4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "lp-card course-hero" }
const _hoisted_2 = { class: "course-hero__main" }
const _hoisted_3 = { class: "course-hero__cover" }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { class: "course-hero__info" }
const _hoisted_6 = { class: "course-hero__eyebrow" }
const _hoisted_7 = { class: "course-hero__title" }
const _hoisted_8 = {
  key: 0,
  class: "course-hero__description"
}
const _hoisted_9 = { class: "course-hero__tags" }
const _hoisted_10 = {
  key: 0,
  class: "lp-tag lp-tag--purple"
}
const _hoisted_11 = {
  key: 1,
  class: "lp-tag lp-tag--grey"
}
const _hoisted_12 = { class: "course-hero__actions" }
const _hoisted_13 = ["title"]
const _hoisted_14 = { class: "course-hero__greeting" }
const _hoisted_15 = { class: "course-hero__stats" }
const _hoisted_16 = { class: "course-hero__progress" }
const _hoisted_17 = { class: "lp-bar" }
const _hoisted_18 = { class: "course-hero__stat" }
const _hoisted_19 = { class: "course-hero__stat-icon" }
const _hoisted_20 = { class: "course-hero__stat" }
const _hoisted_21 = { class: "course-hero__stat-icon" }
const _hoisted_22 = { class: "course-hero__stat-icon" }

import { computed } from 'vue';
import HcIcon from '@/modern/components/ui/HcIcon.vue';
import { FALLBACK_IMAGE, ICourse, ICourseModule, useCourseI18n } from './course';


export default /*#__PURE__*/_defineComponent({
  props: {
    course: null,
    currentModule: null,
    lessonsDone: null,
    lessonsTotal: null,
    modulesDone: null,
    greeting: null,
    userNick: null
  },
  emits: ["share"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'share'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  course: ICourse
  currentModule: ICourseModule | null
  lessonsDone: number
  lessonsTotal: number
  modulesDone: number
  greeting: string
  userNick: string
}





const { t, lang, tc } = useCourseI18n();

const isCompleted = computed(() => props.course.user_status === 'completed');
const hasStarted = computed(() => props.lessonsDone > 0 || props.modulesDone > 0);
const lessonsPercent = computed(() =>
  props.lessonsTotal ? Math.round((props.lessonsDone / props.lessonsTotal) * 100) : 0
);

const status = computed(() => {
  if (isCompleted.value) return { label: t(`${lang.value}.user_progress.completed`), tone: 'green' };
  if (hasStarted.value) return { label: t(`${lang.value}.user_progress.in_progress`), tone: 'amber' };
  return { label: t(`${lang.value}.user_progress.not_started_yet`), tone: 'grey' };
});

const canShare = computed(() => isCompleted.value && props.course.has_achievement && props.course.achievement);
const certificateReady = computed(() => isCompleted.value && props.course.has_certificate);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: __props.course.image_url || _unref(FALLBACK_IMAGE),
          alt: __props.course.name
        }, null, 8, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(HcIcon, {
            name: "video",
            size: 14
          }),
          _createTextVNode(_toDisplayString(_unref(tc)('eyebrow')), 1)
        ]),
        _createElementVNode("h1", _hoisted_7, _toDisplayString(__props.course.name), 1),
        (__props.course.description)
          ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(__props.course.description), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("span", {
            class: _normalizeClass(["lp-tag", `lp-tag--${_unref(status).tone}`])
          }, _toDisplayString(_unref(status).label), 3),
          (__props.course.has_certificate)
            ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                _createVNode(HcIcon, {
                  name: "award",
                  size: 13
                }),
                _createTextVNode(_toDisplayString(_unref(tc)('with_certificate')), 1)
              ]))
            : _createCommentVNode("", true),
          (__props.course.has_achievement)
            ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                _createVNode(HcIcon, {
                  name: "trophy",
                  size: 13
                }),
                _createTextVNode(_toDisplayString(_unref(tc)('with_achievement')), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_12, [
          (__props.currentModule)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                to: { name: 'training-module-show', params: { id: __props.currentModule.id } },
                class: "lp-btn"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(hasStarted) ? _unref(tc)('continue_course') : _unref(tc)('start_course')) + " ", 1),
                  _createVNode(HcIcon, {
                    name: "arrow",
                    size: 16
                  })
                ]),
                _: 1
              }, 8, ["to"]))
            : _createCommentVNode("", true),
          (_unref(certificateReady))
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 1,
                to: "/profile/certificate",
                class: _normalizeClass(["lp-btn", { 'lp-btn--outline': __props.currentModule }])
              }, {
                default: _withCtx(() => [
                  _createVNode(HcIcon, {
                    name: "award",
                    size: 16
                  }),
                  _createTextVNode(" " + _toDisplayString(_unref(tc)('view_certificate')), 1)
                ]),
                _: 1
              }, 8, ["class"]))
            : (__props.course.has_certificate)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 2,
                  class: "lp-btn lp-btn--outline",
                  "aria-disabled": "true",
                  title: _unref(tc)('certificate_locked_hint')
                }, [
                  _createVNode(HcIcon, {
                    name: "lock",
                    size: 16
                  }),
                  _createTextVNode(" " + _toDisplayString(_unref(tc)('certificate')), 1)
                ], 8, _hoisted_13))
              : _createCommentVNode("", true),
          (_unref(canShare))
            ? (_openBlock(), _createElementBlock("button", {
                key: 3,
                type: "button",
                class: "lp-btn lp-btn--outline",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('share')))
              }, [
                _createVNode(HcIcon, {
                  name: "linkedin",
                  size: 16
                }),
                _createTextVNode(" " + _toDisplayString(_unref(t)(`${_unref(lang)}.common.share_on_linkedin`)), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("span", _hoisted_14, [
            _createElementVNode("strong", null, _toDisplayString(__props.userNick), 1),
            _createTextVNode(", " + _toDisplayString(__props.greeting), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("p", null, [
          _createElementVNode("strong", null, _toDisplayString(_unref(lessonsPercent)) + "%", 1),
          _createTextVNode(" " + _toDisplayString(_unref(tc)('lessons_watched_pct')), 1)
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("span", {
            style: _normalizeStyle({ width: `${_unref(lessonsPercent)}%` })
          }, null, 4)
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("span", _hoisted_19, [
          _createVNode(HcIcon, {
            name: "book",
            size: 20
          })
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("strong", null, _toDisplayString(__props.modulesDone) + "/" + _toDisplayString(__props.course.modules.length), 1),
          _createElementVNode("span", null, _toDisplayString(_unref(tc)('modules_completed')), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("span", _hoisted_21, [
          _createVNode(HcIcon, {
            name: "video",
            size: 20
          })
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("strong", null, _toDisplayString(__props.lessonsDone) + "/" + _toDisplayString(__props.lessonsTotal), 1),
          _createElementVNode("span", null, _toDisplayString(_unref(tc)('lessons_watched')), 1)
        ])
      ]),
      (__props.course.has_certificate)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["course-hero__stat", { 'course-hero__stat--locked': !_unref(certificateReady) }])
          }, [
            _createElementVNode("span", _hoisted_22, [
              _createVNode(HcIcon, {
                name: "award",
                size: 20
              })
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("strong", null, _toDisplayString(_unref(certificateReady) ? _unref(tc)('cert_available') : _unref(tc)('cert_locked')), 1),
              _createElementVNode("span", null, _toDisplayString(_unref(tc)('certificate')), 1)
            ])
          ], 2))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})